const HeaderGap = () => (
  <div className="relative w-full h-[70px] md:h-[100px]" />
);

export default HeaderGap;
